import { gql } from 'apollo-boost';

export const GET_MESSAGE_REVISIONS = gql`
    query($data: MessageRevisionsInput!) {
        messageRevisions(data: $data) {
            edges {
                cursor
                node {
                    id
                    messageId
                    revisionNumber
                    createdAt
                    createdBy
                    createdByDisplay
                    reason
                    restoredFromRevisionId
                    snapshot {
                        title
                        body
                        image {
                            name
                            public_id
                            displayName
                            type
                            format
                            size
                            width
                            height
                            aspect_ratio
                            duration
                            mime
                            url
                            downloadUrl
                        }
                        file {
                            name
                            public_id
                            displayName
                            type
                            format
                            size
                            width
                            height
                            aspect_ratio
                            duration
                            mime
                            url
                            downloadUrl
                        }
                    }
                }
            }
            pageInfo {
                nextCursor
                hasMore
            }
        }
    }
`;
